module.exports = __webpack_public_path__ + "img/bg-image-1.6ed980bd.jpg";